import React, { useEffect, useState } from "react";
import TableOne from "../table/TableOne";
import { getRequest, postRequest, deleteRequest } from "../api/api";
import {
  Modal,
  Form,
  Input,
  Upload,
  Button,
  Select,
  message,
  Switch,
} from "antd";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import "./../style/common.css";
import { FaPlus } from "react-icons/fa6";
import { FaEdit } from "react-icons/fa";
import { TbSend } from "react-icons/tb";
import { GiBookshelf } from "react-icons/gi";
import ReactDOMServer from "react-dom/server";
import { FaTrash, FaTimes } from "react-icons/fa";

const Module = () => {
  const [modules, setModules] = useState([]);
  const [categories, setCategories] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editingModule, setEditingModule] = useState(null);
  const [loading, setLoading] = useState(false);
  const [notificationModalVisible, setNotificationModalVisible] =
    useState(false);
  const [notificationLoading, setNotificationLoading] = useState(false);
  const [notificationModule, setNotificationModule] = useState(null);
  const [notificationForm] = Form.useForm();

  const [form] = Form.useForm();

  const getModules = async () => {
    setLoading(true);
    try {
      const response = await getRequest("modules?all=true&isCategory=true");
      setModules(response);
    } catch (error) {
      console.error("Error fetching modules:", error);
    } finally {
      setLoading(false);
    }
  };

  const getCategories = async () => {
    try {
      const response = await getRequest("categories?all=false");
      setCategories(response?.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    getModules();
    getCategories();
  }, []);

  const handleDelete = async (module) => {
const result = await Swal.fire({
  title: `Are you sure?`,
  html: `This will permanently delete <b>${module.name}</b>.`,
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: "#d33",
  cancelButtonColor: "#3085d6",
  confirmButtonText: ReactDOMServer.renderToString(
    <>
      <FaTrash style={{ marginRight: 6, verticalAlign: "middle" }} /> Yes, delete it!
    </>
  ),
  cancelButtonText: ReactDOMServer.renderToString(
    <>
      <FaTimes style={{ marginRight: 6, verticalAlign: "middle" }} /> Cancel
    </>
  ),
  allowOutsideClick: false,
});

    if (result.isConfirmed) {
      try {
        await deleteRequest(`modules/${module.id}`);
        Swal.fire("Deleted!", `"${module.name}" has been deleted.`, "success");
        getModules();
      } catch (error) {
        console.error("Delete Error:", error);
        Swal.fire("Error", "Failed to delete the module.", "error");
      }
    }
  };

  const handleEdit = (module) => {
    setEditMode(true);
    setEditingModule(module);
    form.setFieldsValue({
      category_id: module?.category_id,
      name: module?.name,
      description: module?.description,
      is_active: module?.is_active === 1 || module?.is_active === "1", // ✅ prefill boolean
      image: module?.image
        ? [
            {
              uid: "-1",
              name: "Existing Image",
              status: "done",
              url: module.image,
            },
          ]
        : [],
    });
    setModalVisible(true);
  };

  const handleAdd = () => {
    setEditMode(false);
    form.resetFields();
    setModalVisible(true);
  };

  const handleFormSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("category_id", values.category_id);
    formData.append("name", values.name);
    formData.append("description", values.description || "");
   const isActiveToSend = editMode ? (values?.is_active ? 1 : 0) : 1; // add default 1 on create
formData.append("is_active", isActiveToSend);

    const fileList = values.image;
    const fileItem = fileList?.[0];

    if (fileItem?.originFileObj) {
      // New uploaded image
      formData.append("image", fileItem.originFileObj);
    }

    try {
      if (editMode) {
        await postRequest(`modules/${editingModule.id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Module updated successfully");
      } else {
        await postRequest("modules", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Module added successfully");
      }

      setModalVisible(false);
      getModules();
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error("Something went wrong");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // send notification

  const handleSendNotification = (module) => {
    setNotificationModule(module);
    // notificationForm.resetFields();
    setNotificationModalVisible(true);
  };

  const submitNotification = async (values) => {
    if (!notificationModule) return;
    setNotificationLoading(true);

    const payload = {
      title: values.title,
      body: values.body,
      data: {
        type: "module",
        moduleId: notificationModule?.id,
        title: notificationModule?.name,
        image: notificationModule?.image || "",
        description: notificationModule?.description || "",
      },
    };

    try {
      await postRequest("notify/all-users", payload);
      message.success("Notification sent successfully");
      setNotificationModalVisible(false);
    } catch (error) {
      console.error("Notification Error:", error);
      message.error("Failed to send notification");
    } finally {
      setNotificationLoading(false);
    }
  };

  // inside component
  useEffect(() => {
    if (notificationModalVisible) {
      notificationForm.setFieldsValue({
        title: notificationModule?.name || "",
        body: "",
      });
    }
  }, [notificationModule, notificationModalVisible, notificationForm]);

  const columns = [
    {
      title: "Sr. No.",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Image",
      key: "image",
      render: (_, record) => {
        const fallbackImage =
          "https://pranafreshharvest.com/profile_images/profile_20251108054906.png";
        const imageUrl = record.image || fallbackImage;
        return (
          <img
            src={imageUrl}
            alt="Submodule"
            width={60}
            height={40}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = fallbackImage;
            }}
          />
        );
      },
    },
    {
      title: "Module",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Specialities",
      key: "category",
      render: (_, record) => record.category?.name || "N/A",
    },

    {
      title: "Status",
      dataIndex: "is_active",
      key: "status",
      render: (value) => {
        const isActive = value === 1 || value === "1";
        return (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              color: isActive ? "#10b981" : "#ef4444",
              fontWeight: "500",
            }}
          >
            <span
              style={{
                height: "8px",
                width: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10b981" : "#ef4444",
                display: "inline-block",
              }}
            />
            {isActive ? "Active" : "Inactive"}
          </span>
        );
      },
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <div className="header-button">
<h2
  style={{
    color: "#5a355a",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    lineHeight: 1,
  }}
>
  <GiBookshelf />
  <span>Module</span>
  <span
    style={{
      color: "#979797ff",
      fontSize: "14px",
      fontWeight: 500,
      alignSelf: "flex-end", // bottom-align just the total
    }}
  >
    (Total: {modules?.length ?? 0})
  </span>
</h2>
        <Button
          type="primary"
          onClick={handleAdd}
          icon={<PlusOutlined />}
          style={{ marginBottom: 20 }}
          className="add-btn"
        >
          Add Module
        </Button>
      </div>

      <TableOne
        columns={columns}
        data={modules}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        loading={loading}
        pageName="module"
        handleSendNotification={handleSendNotification}
      />

      <Modal
        title={editMode ? "Update Module" : "Add Module"}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        destroyOnClose
        maskClosable={false}
      >
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Form.Item
            name="category_id"
            label="Specialities"
            rules={[{ required: true, message: "Select a Specialities" }]}
          >
            <Select
              showSearch
              placeholder="Select Specialities"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              style={{ width: "100%", borderRadius: 6 }}
              dropdownStyle={{ borderRadius: 6 }}
            >
              {categories.map((cat) => (
                <Select.Option key={cat.id} value={cat.id}>
                  {cat.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="name"
            label="Module Name"
            rules={[{ required: true, message: "Required Module Name" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            // rules={[{ required: true, message: "Please enter a description" }]}
          >
            <Input.TextArea
              rows={6}
              style={{ minHeight: "120px", resize: "vertical" }}
            />
          </Form.Item>

          <Form.Item
            name="image"
            label="Image"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
            className="custom-form-label"
          >
            <Upload
              listType="picture"
              beforeUpload={() => false}
              accept="image/*"
              maxCount={1}
            >
              <Button icon={<UploadOutlined />}>Upload Image</Button>
            </Upload>
          </Form.Item>

    {editMode && (
  <Form.Item noStyle shouldUpdate>
    {({ getFieldValue }) => {
      const on = !!getFieldValue("is_active");
      return (
        <Form.Item
          name="is_active"
          label="Status"
          valuePropName="checked"
          className="custom-form-label"
        >
          <Switch
            checkedChildren="Active"
            unCheckedChildren="Inactive"
            className={`status-switch ${on ? "on" : "off"}`}
          />
        </Form.Item>
      );
    }}
  </Form.Item>
)}


          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
              icon={editMode ? <FaEdit /> : <FaPlus />}
            >
              {editMode ? "Update Module" : "Add Module"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Send Notification"
        open={notificationModalVisible}
        onCancel={() => {
          setNotificationModalVisible(false);
          notificationForm.resetFields();
          setNotificationModule(null);
        }}
        footer={null}
        destroyOnClose
        maskClosable={false}
      >
        {notificationModule && (
          <div>
            <div
              style={{
                marginBottom: 16,
                border: "1px solid #e0e0e0",
                padding: 16,
                borderRadius: 8,
                backgroundColor: "#fafafa",
                display: "flex",
                gap: 16,
                alignItems: "flex-start",
              }}
            >
              <img
                src={
                  notificationModule.image ||
                  "https://physio.pranafreshharvest.com/physio-logo.png"
                }
                alt={notificationModule.name}
                style={{
                  width: 80,
                  height: 80,
                  objectFit: "contain",
                  borderRadius: 6,
                  flexShrink: 0,
                }}
              />

              <div style={{ flex: 1 }}>
                <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 600 }}>
                  {notificationModule.name}
                </h3>
                <p style={{ marginTop: 6, fontSize: "14px", color: "#555" }}>
                  {notificationModule.description ||
                    "No description available."}
                </p>
              </div>
            </div>
          </div>
        )}

        <Form
          key={notificationModule?.id || "notify"}
          form={notificationForm}
          layout="vertical"
          onFinish={submitNotification}
        >
          <Form.Item
            name="title"
            label="Notification Title"
            rules={[{ required: true, message: "Please enter a title" }]}
          >
            <Input placeholder="Enter notification title" allowClear />
          </Form.Item>

          <Form.Item
            name="body"
            label="Notification Body"
            // rules={[{ required: true, message: "Please enter a body" }]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Enter notification body"
              style={{ resize: "vertical" }}
            />
          </Form.Item>

          <p style={{ fontSize: 13, color: "#dc2626", fontWeight: 600 }}>
            * This notification will be sent to all users.
          </p>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={notificationLoading}
              // loading={loading}
              icon={<TbSend />}
            >
              Send Notification
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Module;
